import PresentationTypeDetail from './PresentationTypeDetail';

export default PresentationTypeDetail;
